import { useEffect, useRef, useState } from "react";
import {
  Button,
  Dropdown,
  DropdownButton,
  Form,
  InputGroup,
  Modal,
} from "react-bootstrap";
import { API_URL, NEW_API_URL } from "../../../constants/Globals";
import axios from "axios";
import { addStepToSequence } from "../../../services/CollectionsSvc";
import CustomColorPicker from "../CustomColorPicker";

const AddEditCallToActionModal = ({
  show = true,
  onClose,
  contentCallToActionId,
  sequenceId,
  orderNumber,
  match,
  selNetworkId,
}) => {
  const hexColorRegex = /^#([0-9A-F]{3}){1,2}$/i;
  // console.log('contentCallToActionId.....', contentCallToActionId);
  const [title, setTitle] = useState("");
  const [titleColor, setTitleColor] = useState("#333333");
  const [titleFontSize, setTitleFontSize] = useState("24px");

  const [description, setDescription] = useState("");
  const [descriptionColor, setDescriptionColor] = useState("#333333");
  const [descriptionFontSize, setDescriptionFontSize] = useState("16px");

  const [buttonText, setButtonText] = useState("");
  const [buttonColor, setButtonColor] = useState("#ffffff");
  const [buttonFontSize, setButtonFontSize] = useState("16px");
  const [buttonTextColor, setButtonTextColor] = useState("#333333");

  const [linkToNextStep, setLinkToNextStep] = useState(false);

  const [buttonLink, setButtonLink] = useState("");

  const [backgroundColor, setBackgroundColor] = useState("#ffffff");

  const [ctaImage, setCtaImage] = useState(null);
  const ctaImgFileInputRef = useRef();
  const [backgroundImage, setBackgroundImage] = useState(null);
  const bgImgFileInputRef = useRef();

  const handleSelect = (selected) => {
    setTitleFontSize(selected);
  };

  const handleCheckboxChange = (e) => {
    setLinkToNextStep(e.target.checked); // Updates state when the checkbox is toggled
  };

  //-- to get pixel list
  const pxOptions = Array.from({ length: 30 }, (_, i) => `${i + 1}px`);
  const renderPxDropdown = (id, onSelectCallback) => (
    <DropdownButton
      className="customDropdown w-25 me-3 standard-dropdown"
      variant="outline-secondary"
      size="sm"
      title=""
      id={id}
      align="end"
      onSelect={(selected) => onSelectCallback(selected)}
    >
      {pxOptions.map((option) => (
        <Dropdown.Item key={option} eventKey={option} as="button">
          {option}
        </Dropdown.Item>
      ))}
    </DropdownButton>
  );

  const kTrans = (str) => str;
  // useEffect(() => {
  //     alert(`Color changed to: ${backgroundColor}`);
  // }, [backgroundColor]);
  useEffect(() => {
    if (contentCallToActionId > 0) fetchContentCallToActionById();
  }, [contentCallToActionId]);

  const fetchContentCallToActionById = async () => {
    try {
      const response = await axios.get(
        `${NEW_API_URL}/call-to-action/${contentCallToActionId}`
      );
      // console.log("Response from server:", response.data);
      if (response.data) {
        const data = response.data.data;
        setTitle(data.title);
        setDescription(data.description);
        setButtonText(data.buttonText);
        setButtonLink(data.buttonLink);
        setTitleColor(data.styleTitle.color);
        setTitleFontSize(data.styleTitle.fontSize);
        setDescriptionColor(data.styleDescription.color);
        setDescriptionFontSize(data.styleDescription.fontSize);
        setButtonColor(data.styleButton.color);
        setButtonFontSize(data.styleButton.fontSize);
        setLinkToNextStep(data.linkToNextStep);
        setButtonTextColor(data.styleButton.textColor);
        setBackgroundColor(data.styleBackground.color);
        if (data.ctaImage) {
          setCtaImage(data.ctaImage);
        }
        if (data.backgroundImage) {
          setBackgroundImage(data.backgroundImage);
        }
      }
    } catch (error) {
      console.error("Error fetching content call to action by ID:", error);
    }
  };

  const handleCtaImageUploadClick = () => {
    ctaImgFileInputRef.current.click();
  };
  const handleCtaImageFileChange = (e) => {
    const ctaFileObj = e.target.files[0];
    if (ctaFileObj) {
      // console.log('Image file detail:', ctaFileObj, URL.createObjectURL(ctaFileObj));
      // setCtaImage(URL.createObjectURL(ctaFileObj)); // for preview
      uploadImageToS3("ctaImage", ctaFileObj);
    }
  };
  const handleBgImageUploadClick = () => {
    bgImgFileInputRef.current.click();
  };
  const handleBgImageFileChange = (e) => {
    const bgFileObj = e.target.files[0];
    if (bgFileObj) {
      // console.log('Image file detail:', bgFileObj, URL.createObjectURL(bgFileObj));
      // setCtaImage(URL.createObjectURL(bgFileObj)); // for preview
      uploadImageToS3("backgroundImage", bgFileObj);
    }
  };

  const uploadImageToS3 = async (imageInpSrc, fileObj) => {
    const formData = new FormData();
    formData.append("ctaBgFile", fileObj);
    formData.append("key", fileObj.name);

    try {
      const response = await axios.post(
        `${NEW_API_URL}/call-to-action/upload-image`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      // console.log("Image uploaded successfully:", response.data);
      if (response.data) {
        if (imageInpSrc === "ctaImage") {
          setCtaImage(response.data.data);
        } else {
          setBackgroundImage(response.data.data);
        }
      } else {
        console.error("Image upload failed:", response.data);
        alert("Error in file upload.");
        return false;
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  function validateInputs() {
    if (title.trim() === "") {
      alert("Please enter call to action title.");
      return false;
    }
    if (description.trim() === "") {
      alert("Please enter call to action description.");
      return false;
    }
    if (buttonText.trim() === "") {
      alert("Please enter call to action button text.");
      return false;
    }
    if (!linkToNextStep && buttonLink.trim() === "") {
      alert("Please enter call to action button link.");
      return false;
    }

    if (hexColorRegex.test(titleColor) == false) {
      alert("Title color is not valid.");
      return false;
    }
    if (hexColorRegex.test(descriptionColor) == false) {
      alert("Description color is not valid.");
      return false;
    }
    if (hexColorRegex.test(buttonTextColor) == false) {
      alert("Button text color is not valid.");
      return false;
    }
    if (hexColorRegex.test(buttonColor) == false) {
      alert("Button color is not valid.");
      return false;
    }
    if (hexColorRegex.test(backgroundColor) == false) {
      alert("Background color is not valid.");
      return false;
    }
    return true;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateInputs();
    if (!isValid) {
      return false;
    }
    try {
      let closeModelAf = 1;
      let callToActionRecId = null;
      const url =
        contentCallToActionId > 0
          ? `${NEW_API_URL}/call-to-action/${contentCallToActionId}`
          : `${NEW_API_URL}/call-to-action`;
      const method = contentCallToActionId > 0 ? "PUT" : "POST";
      let nextId = null;
      await axios
        .request({
          url,
          method,
          data: {
            // id: id,
            title: title,
            description: description,
            buttonText: buttonText,
            buttonLink: buttonLink,
            styleTitle: { color: titleColor, fontSize: titleFontSize },
            styleDescription: {
              color: descriptionColor,
              fontSize: descriptionFontSize,
            },
            styleButton: {
              color: buttonColor,
              fontSize: buttonFontSize,
              textColor: buttonTextColor,
            },
            linkToNextStep: linkToNextStep,
            styleBackground: { color: backgroundColor },
            ctaImage: ctaImage ? ctaImage : null,
            backgroundImage: backgroundImage ? backgroundImage : null,
          },
        })
        .then(({ data }) => {
          const response = data;
          callToActionRecId = response.data;
          // if (data.status == 1) {
          //     //onClose(true);
          // }
        });

      if (callToActionRecId && !contentCallToActionId) {
        try {
          const payload = {
            sequenceId: sequenceId,
            order: orderNumber + 1,
            isBranch: false,
            partType: "CTA",
            partId: callToActionRecId,
          };

          const response = await addStepToSequence(payload);
          nextId = response.data.data;
        } catch (error) {
          closeModelAf = 0;
          console.error(
            "Failed to add step to sequence due to step part:",
            error
          );
          alert(
            "Failed to add step to sequence due to step part. Please try again."
          );
        }
      }
      if (closeModelAf == 1) {
        onClose(nextId);
      }
      console.log("Call to action ends...");
    } catch (error) {
      console.error("Error in saving callToAction:", error);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="lg"
      dialogClassName="w-100"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {contentCallToActionId > 0
            ? "Edit Custom Call to Action"
            : "Create a Custom Call to Action"}{" "}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit} className="common-form sided-form">
          <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
            <Form.Group className="" style={{ flex: 4 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("Title")}</b>
              </Form.Label>
              <Form.Control
                type="text"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
                id="title"
                name="title"
                className="w-100"
                placeholder={kTrans("Add a title")}
                // style={{ width: '100px', height: '40px', padding: '0' }}
              />
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("")}&nbsp;</b>
              </Form.Label>
              <InputGroup className="w-100 color-picker-container">
                <CustomColorPicker
                  color={titleColor}
                  onChange={(newColor) => setTitleColor(newColor)}
                />
                <Form.Control
                  type="text"
                  value={titleColor}
                  style={{
                    border: "0px solid #ced4da",
                    borderRadius: "0 0.25rem 0.25rem 0",
                  }}
                  onChange={(e) => {
                    setTitleColor(e.target.value);
                  }}
                />
              </InputGroup>
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("")}&nbsp;</b>
              </Form.Label>
              <DropdownButton
                className="customDropdown w-30 standard-dropdown"
                id="responseCountTarget"
                title={
                  pxOptions.find((item) => item === titleFontSize) ?? "N/A"
                }
              >
                {pxOptions.map((option, i) => (
                  <Dropdown.Item
                    key={option}
                    eventKey={option}
                    onClick={(e) => setTitleFontSize(option)}
                  >
                    {option}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            </Form.Group>
          </div>

          {/* Description fields */}
          <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
            <Form.Group className="" style={{ flex: 4 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("Description")}</b>
              </Form.Label>
              <Form.Control
                type="text"
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
                id="description"
                name="description"
                className="w-100"
                placeholder={kTrans("Enter a description")}
              />
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("")}&nbsp;</b>
              </Form.Label>
              <InputGroup className="w-100 color-picker-container">
                <CustomColorPicker
                  color={descriptionColor}
                  onChange={(newColor) => setDescriptionColor(newColor)}
                />
                <Form.Control
                  type="text"
                  value={descriptionColor}
                  style={{ border: "0px" }}
                  onChange={(e) => {
                    setDescriptionColor(e.target.value);
                  }}
                />
              </InputGroup>
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("")}&nbsp;</b>
              </Form.Label>
              <DropdownButton
                className="customDropdown w-30 standard-dropdown"
                id="responseCountTarget"
                title={
                  pxOptions.find((item) => item === descriptionFontSize) ??
                  "N/A"
                }
              >
                {pxOptions.map((option, i) => (
                  <Dropdown.Item
                    key={option}
                    eventKey={option}
                    onClick={(e) => setDescriptionFontSize(option)}
                  >
                    {option}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            </Form.Group>
          </div>
          {/* Button text fields */}
          <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
            <Form.Group className="" style={{ flex: 4 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("Button Text")}</b>
              </Form.Label>
              <Form.Control
                type="text"
                value={buttonText}
                onChange={(e) => {
                  setButtonText(e.target.value);
                }}
                id="buttonText"
                name="buttonText"
                className="w-100"
                placeholder={kTrans("Enter button text")}
              />
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("")}&nbsp;</b>
              </Form.Label>
              <InputGroup className="w-100 color-picker-container">
                <CustomColorPicker
                  color={buttonTextColor}
                  onChange={(newColor) => setButtonTextColor(newColor)}
                />
                <Form.Control
                  type="text"
                  value={buttonTextColor}
                  style={{ border: "0px" }}
                  onChange={(e) => {
                    setButtonTextColor(e.target.value);
                  }}
                />
              </InputGroup>
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <b className="text-sm-start">{kTrans("")}&nbsp;</b>
              </Form.Label>
              <DropdownButton
                className="customDropdown w-30 standard-dropdown"
                id="responseCountTarget"
                title={
                  pxOptions.find((item) => item === buttonFontSize) ?? "N/A"
                }
              >
                {pxOptions.map((option, i) => (
                  <Dropdown.Item
                    key={option}
                    eventKey={option}
                    onClick={(e) => setButtonFontSize(option)}
                  >
                    {option}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
            </Form.Group>
          </div>
          {/* Button link fields */}
          <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
            <Form.Group className="" style={{ flex: 4 }}>
              <div className="d-flex justify-content-between align-items-center">
                <Form.Label className="mb-0 w-50">
                  <b className="text-sm-start">{kTrans("Button Link")}</b>
                </Form.Label>
                <div className="w-50 d-flex justify-content-end align-items-center">
                  <Form.Label>
                    <span className="text-muted me-2 text form-label text-font">
                      {kTrans("Link to next step")}
                    </span>
                  </Form.Label>
                  <Form.Check.Input
                    className="toggle-checkbox small"
                    style={{ margin: "5px 15px" }}
                    checked={!!linkToNextStep}
                    onChange={handleCheckboxChange}
                    name="linkToNextStep"
                    value={linkToNextStep}
                    data-type="Link to next step"
                  />
                </div>
              </div>
              <Form.Control
                type="text"
                value={buttonLink}
                onChange={(e) => {
                  setButtonLink(e.target.value);
                }}
                id="buttonLink"
                name="buttonLink"
                className="w-100"
                placeholder={kTrans("Enter button link")}
              />
            </Form.Group>
            <Form.Group className="" style={{ flex: 1 }}>
              <Form.Label>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    margin: "3px 0px",
                  }}
                >
                  <b className="text-sm-start">
                    {kTrans("Button Color")}&nbsp;
                  </b>
                </span>
              </Form.Label>
              <InputGroup className="w-100 color-picker-container">
                <CustomColorPicker
                  color={buttonColor}
                  onChange={(newColor) => setButtonColor(newColor)}
                />
                <Form.Control
                  type="text"
                  value={buttonColor}
                  style={{ border: "0px" }}
                  onChange={(e) => {
                    setButtonColor(e.target.value);
                  }}
                />
              </InputGroup>
            </Form.Group>
            <div style={{ flex: 1 }}></div>
          </div>
          {/* Image fields */}
          <div
            className="d-flex justify-content-start align-items-center flex-row"
            style={{ marginBottom: "2rem" }}
          >
            <Form.Group className="">
              <Form.Label>
                <b className="text-sm-start">{kTrans("CTA Image")}&nbsp;</b>
              </Form.Label>
              <Button
                variant="outline-primary"
                size="md"
                onClick={handleCtaImageUploadClick}
              >
                {ctaImage ? "Uploaded" : "Upload Image"}
              </Button>
              <Form.Control
                type="file"
                accept="image/*"
                ref={ctaImgFileInputRef}
                onChange={handleCtaImageFileChange}
                style={{ display: "none" }} // hide actual file input
              />
            </Form.Group>
            <Form.Group className="ms-4">
              <Form.Label>
                <b className="text-sm-start">
                  {kTrans("Background Image")}&nbsp;
                </b>
              </Form.Label>
              <Button
                variant="outline-primary"
                size="md"
                onClick={handleBgImageUploadClick}
              >
                {backgroundImage ? "Uploaded" : "Upload Image"}
              </Button>
              <Form.Control
                type="file"
                accept="image/*"
                ref={bgImgFileInputRef}
                onChange={handleBgImageFileChange}
                style={{ display: "none" }} // hide actual file input
              />
            </Form.Group>
            <Form.Group className="ms-4">
              <Form.Label>
                <b className="text-sm-start">
                  {kTrans("Background Color")}&nbsp;
                </b>
              </Form.Label>
              <InputGroup className="w-5 color-picker-container">
                <CustomColorPicker
                  color={backgroundColor}
                  onChange={(newColor) => setBackgroundColor(newColor)}
                />
                <Form.Control
                  type="text"
                  value={backgroundColor}
                  style={{ border: "0px" }}
                  onChange={(e) => {
                    setBackgroundColor(e.target.value);
                  }}
                />
              </InputGroup>
            </Form.Group>
          </div>

          <div className="center">
            <button type="submit" className="blue-button size-l">
              Save
            </button>
          </div>
        </Form>
      </Modal.Body>
      {/* <Modal.Footer> */}
      {/* <Button variant="secondary" onClick={onClose}>Close</Button> */}
      {/* <Button variant="primary" onClick={() => alert("Confirmed!")}>Save</Button> */}
      {/* </Modal.Footer> */}
    </Modal>
  );
};

export default AddEditCallToActionModal;
